module.exports = __webpack_public_path__ + "img/颁奖台.8dd0dd56.png";